import type { LinkType, SitecoreLink } from 'models/sitecore';
import type { PartialIdString, WithRequired } from 'types';
import { withTruthyProps } from 'utils/collection';

type NonPopoverLink = SitecoreLink & {
	linktype?: Exclude<LinkType, 'popover'>;
};
type ValidNonPopoverLink = WithRequired<NonPopoverLink, 'text'>;

type PopoverLink = SitecoreLink & {
	href: PartialIdString;
	linktype: 'popover';
};
export type ValidPopoverLink = WithRequired<PopoverLink, 'text' | 'title'>;

export type ValidSitecoreLink = ValidNonPopoverLink | ValidPopoverLink;

export function getValidSitecoreLink(
	link: SitecoreLink | undefined,
): ValidSitecoreLink | undefined {
	// TS can't narrow the removal of 'popover' in the else branch so without
	// casting it wants a required title there too.
	return link?.linktype === 'popover'
		? withTruthyProps(link as PopoverLink | undefined, 'href', 'text', 'title')
		: withTruthyProps(link as NonPopoverLink | undefined, 'href', 'text');
}
